// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__eWuOZ","nopadding":"Loading_nopadding__Ftqty"};